import type { Plugin } from 'vue';
import type { Router } from 'vue-router';
import { useEventBus } from '@/app/core/event-bus';
import { addRecentlyVisited } from '@/react-app/recently-visited/stores';
import { useRecentlyVisitedStore } from './stores';

interface Options {
  router: Router;
}

export function createRecentlyVisited(options: Options): Plugin {
  return {
    install() {
      const { router } = options;
      const eventBus = useEventBus();
      const store = useRecentlyVisitedStore();

      router.afterEach(async (to, from) => {
        if (to.meta.trackVisit && to.path !== from.path) {
          store.add(to); // Existing Pinia store (Vue fallback)
          await addRecentlyVisited(to); // New Zustand store (React) - await to resolve title functions
        }
      });

      eventBus.on('appInitialized', async () => {
        await store.fetch();
        // Remove invalid records
        store.records = store.records.filter(({ path }) => !!router.resolve(path));
      });
    },
  };
}

export * from './stores';
export * from './components';
